<template>
    <div class="card page-height">
        <div class="card-header">
            <h4 class="card-title mb-0">Select Products</h4>
        </div>
        <div class="card-body form-steps">
            <div class="select-step">
                <!-- progressbar -->
                <ul id="progressbar" class="mb-4">
                    <li ><span>Select Customer</span></li>
                    <li ><span>Select Quotes</span></li>
                    <li class="active"><span>Select Products</span></li>
                    <li><span>Provide Other Info</span></li>
                </ul>

                <!-- fieldsets -->
                <fieldset class="search">
                    <div class="row">
                        <div class="col-sm-7 col-md-7">
                            <form class="form-inline" action="" @submit.prevent="search()">
                            <div class="autocomplete-form">
                                <autocomplete
                                    :source="productSearchEndpoint"
                                    :requestHeaders="authHeaders"
                                    :resultsFormatter="resultsFormatter"
                                    :resultsDisplay="formattedDisplay"
                                    :name="'filter_data'"
                                    :initialDisplay="initialDisplay"
                                    ref="autocomplete"
                                    placeholder="Quick Search"
                                    input-class="form-control"
                                    @input="inputFilterProduct($event)"
                                    @selected="selectFilterProduct($event)"
                                    @clear="selectFilterProduct(null)"
                                />
                                <!--<input v-model="search_filter" type="text" class="form-control" placeholder="Quick Search">
                                <button class="btn btn-outline-secondary custom-btn" type="button" @click.prevent="search"><i class="fa fa-search" aria-hidden="true"></i></button>-->

                                </div>
                            </form>
                        </div>
                        <div class="col-sm-5 col-md-5">
                            <div class="title-right new-custom-sec2 float-right">
                                <!--<template v-if="newOrder.id">
                                <button type="button" v-on:click="manualSubmit" :disabled="newOrder.products.length == 0 || ordersLoading || loading || saveDone == true"
                                        class="btn custom-btn ml-3">Save
                                </button>
                            </template>
                            <template v-else>
                                <button type="button" class="btn custom-btn ml-3" v-on:click="manualSubmit"
                                        :disabled="newOrder.products.length == 0 || loading || productsLoading || quoteProductsLoading">Next
                                </button>
                            </template>-->
                            <a href="javascript:void(0)" class="btn custom-btn" data-toggle="modal" data-target="#productAddModal"><i class="ri-add-circle-line align-middle pe-1"></i> Create Product</a>

                            </div>
                        </div>
                    </div>
                </fieldset>

                <ValidationObserver v-slot="{ handleSubmit }" ref="form">
                    <form @submit.prevent="handleSubmit(submitHandler)" ref="orderForm" method="post">
                        <div class="tabsinner-content3 mb-4">
                            <!-- Nav tabs -->
                            <ul class="nav nav-tabs bg-light mb-2">
                                <li class="nav-item">
                                    <a class="nav-link" :class="[selectedTab == 1 ? 'active': '']" data-toggle="tab"
                                    href="#quoteProducts" @click="selectTab(1)">Quote Products</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="[selectedTab == 2 ? 'active': '']" data-toggle="tab"
                                    href="#allProducts" @click="selectTab(2)">All Products</a>
                                </li>
                            </ul>
                            <!-- Tab panes -->
                            <div class="tab-content">
                                <div class=" table-margin quote-step03">
                                    <div class="tab-pane" :class="[selectedTab == 1 ? 'active': 'fade']" id="quoteProducts">
                                        <QuotationProducts v-if="selectedTab == 1"
                                                        :customer_id="newOrder.customer_id"
                                                        :selectedProducts="newOrder.selectedProducts" :search_filter="search_filter"
                                                        :quotations="newOrder.quotations"
                                                        :quantityUnits="quantityUnits"
                                                        :products="newOrder.products"
                                                        @selectProduct="selectProduct($event, true)"
                                                        @watchChangedProducts="watchChangedProducts($event, true)" :bus="bus"
                                                        ref="quotationProductsList"
                                        ></QuotationProducts>
                                    </div>
                                    <div class="tab-pane" :class="[selectedTab == 2 ? 'active': 'fade']" id="allProducts">
                                        <Products v-if="selectedTab == 2"
                                                :customer_id="newOrder.customer_id" :selectedProducts="newOrder.selectedProducts"
                                                :search_filter="search_filter"
                                                :quantityUnits="quantityUnits"
                                                :exclude_products="null"
                                                :products="newOrder.products"
                                                @selectProduct="selectProduct($event, false)"
                                                @watchChangedProducts="watchChangedProducts($event, false)" :bus="bus" ref="productsList"
                                        ></Products>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="btnrow text-right ">
                            <button type="button" @click="goBack" class="btn btn-light btn-label left-btn previestab w-lg" data-previous="steparrow-gen-info-tab"><i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back</button>
                            <template v-if="newOrder.id">
                                <button type="submit" :disabled="newOrder.products.length == 0 || ordersLoading || loading || saveDone == true"
                                        class="btn custom-btn ml-3">Save
                                </button>
                            </template>
                            <template v-else>
                                <button type="submit" class="btn btn-success right btn-label ml-3" ref="submitButton"
                                        :disabled="newOrder.products.length == 0 || loading || productsLoading || quoteProductsLoading"><i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i> Next
                                </button>
                            </template>

                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>



        <ProductAddModal @productDataSaved="newProductCreated($event)"></ProductAddModal>
    </div>
</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Vue from "vue";
import Products from "../../components/Products";
import QuotationProducts from "../../components/QuotationProducts";
//import Autocomplete from 'vuejs-auto-complete';
import Autocomplete from "../../components/Autocomplete";

import {ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate';
import ProductAddModal from "../../components/ProductAddModal";

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
})

/*
import { required, min_value } from 'vee-validate/dist/rules';
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
*/

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});

export default {
    name: "SelectProducts",
    components: {
        Products,
        QuotationProducts,
        Autocomplete,
        ValidationObserver, ValidationProvider,
        ProductAddModal
    },
    created() {
        if (localStorage.getItem('token')) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getQuantityUnits();
        if (this.salesOrderState) {
            this.newOrder = this.salesOrderState.newOrder;
        }

        this.selectedTab = 2;
        if (this.newOrder.quotations.length > 0) {
            this.selectedTab = 1;
        }
    },
    beforeRouteLeave (to, from , next) {
        if(to.name == 'selectQuotes' || to.name == 'provideOtherInfo' || to.name == 'selectCustomer' || this.saveDone) {
            next();
        } else {
            const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
            if (answer) {
                next();
            } else {
                next(false);
            }
        }
    },
    data() {
        return {
            bus: new Vue(),
            newOrder: {
                id: null,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: []
                },
                products: [],
                selectedProducts: [],
            },
            search_filter: null,
            selectedTab: 2,
            quantityUnits: [],
            saveDone: false,
            submitted: false,
            initialDisplay: null
        }
    },
    mounted() {

    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setNewOrder',
            'setOrdersLoading',
            'setLoading'
        ]),
        selectTab(tab) {
            this.selectedTab = tab;
            //this.newOrder.products = [];
            //this.newOrder.selectedProducts = [];
            this.setNewOrder(this.newOrder);
        },
        goBack() {
            if(this.newOrder.quotations && this.newOrder.quotations.length > 0) {
                this.$router.push({name: 'selectQuotes'});
            } else {
                this.$router.push({name: 'selectCustomer'});
            }
        },
        newProductCreated(event) {
            let data = {c: event.data, checked: true};
            this.bus.$emit('addNewProduct', event.data);
            this.selectProduct(data);
            this.search();
        },
        manualSubmit(){
            this.$refs.submitButton.click();
        },
        submitHandler() {
            this.$refs.form.validate().then(success => {
                if (!success) {
                    return;
                }
                if(this.newOrder.id) {
               // alert("here");
                    this.saveOrder();
                } else {
                    // alert("there");
                    this.$router.push({name: 'provideOtherInfo'});
                }
            });
        },
        saveOrder(e) {
            if (this.saveDone) {
                self.setSuccessMessage('Order data already saved!');
                return false;
            }
            if(this.selectedTab == 1) {
                this.newOrder.products = this.newOrder.products.filter((x) => this.newOrder.selectedProducts.includes(x.quote_product_id));
            } else {
                this.newOrder.products = this.newOrder.products.filter((x) => this.newOrder.selectedProducts.includes(x.product_id));
            }

            let self = this;
            this.submitted = true;
            this.setOrdersLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            if (typeof this.newOrder.id != 'undefined' && this.newOrder.id != null && this.newOrder.id != '') {
                let newOrder = _.cloneDeep(this.newOrder);
                newOrder.products.forEach((x) => {
                    x.quantity = x.qty;
                })
                return axios.put(window.route('orders.update', {id: this.newOrder.id}), newOrder, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                            if (data.errors) {
                                self.setCommonErrors(data.errors);
                            }
                            this.submitted = false;
                        } else {
                            self.saveDone = true;
                            self.setSuccessMessage('Product saved successfully!');
                            this.setNewOrder({
                                id: null,
                                is_draft: 0,
                                is_stocking: 0,
                                stocking_terms: null,
                                warehouses: [],
                                customerWarehouses: [],
                                billTo: [],
                                customer_id: null,
                                sales_rep_id: null,
                                order_number: null,
                                order_date: null,
                                customer_terms: null,
                                customer_po: null,
                                eta: null,
                                fob: null,
                                notes: null,
                                customer_notes: null,
                                quotations: [],
                                customer: {
                                    quotations_after_sent_to_customer: []
                                },
                                products: [],
                                selectedProducts: [],
                            });
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                                self.saveDone = true;
                                self.$router.push({name: 'orderShow', params: {id: data.data.id}});
                            }, 10);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                        this.submitted = false;
                    })
                    .finally(() => {
                        self.setOrdersLoading(false);

                    });
            } else {
                return axios.put(URL, this.newOrder, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                            if (data.errors) {
                                self.setCommonErrors(data.errors);
                            }
                            this.submitted = false;
                        } else {
                            self.saveDone = true;
                            self.setSuccessMessage('Order created successfully!');
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                                self.$router.push({name: 'orderShow', params: {id: data.data.id}});
                            }, 10);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                        this.submitted = false;
                    })
                    .finally(() => {
                        self.setOrdersLoading(false);

                    });
            }


        },
        selectProduct(event, is_quote) {
            //console.log(event.c.id, event.checked, is_quote)
            if(is_quote) {
                if (event.c) {
                    if (this.newOrder.selectedProducts.includes(event.c.quote_product_id)) {
                        if (event.checked == false) {
                            this.newOrder.selectedProducts.splice(this.newOrder.selectedProducts.indexOf(event.c.quote_product_id), 1);
                        }
                    } else {
                        this.newOrder.selectedProducts.push(event.c.quote_product_id);
                    }

                    if (this.newOrder.products.filter((x) => x.quote_product_id == event.c.quote_product_id).length) {
                        if (event.checked == false) {
                            this.newOrder.products = this.newOrder.products.filter((x) => x.quote_product_id != event.c.quote_product_id);
                        }
                    } else {
                        let product = _.cloneDeep(event.c);
                        product.product_id = event.c.product_id ? event.c.product_id : null;
                        product.id = null;
                        product.selectionTab = 1;
                        this.newOrder.products.push(product);
                    }
                }
                //this.newOrder.products = this.newOrder.products.filter((x) => this.newOrder.selectedProducts.includes(x.quote_product_id));
            } else {
                if (event.c && event.c.id != null) {
                    if (this.newOrder.selectedProducts.includes(event.c.id)) {
                        if (event.checked == false) {
                            this.newOrder.selectedProducts.splice(this.newOrder.selectedProducts.indexOf(event.c.id), 1);
                        }
                    } else {
                        this.newOrder.selectedProducts.push(event.c.id);
                    }

                    if (this.newOrder.products.filter((x) => x.product_id == event.c.id).length) {
                        if (event.checked == false) {
                            this.newOrder.products = this.newOrder.products.filter((x) => x.product_id != event.c.id);
                        }
                    } else {
                        let product = _.cloneDeep(event.c);
                        product.product_id = event.c.id;
                        product.id = null;
                        product.selectionTab = 2;
                        this.newOrder.products.push(product);
                    }
                } else {
                    this.newOrder.selectedProducts.splice(this.newOrder.selectedProducts.indexOf(event.c.product_id), 1);
                    this.newOrder.products = this.newOrder.products.filter((x) => x.product_id != event.c.product_id);
                }
                //this.newOrder.products = this.newOrder.products.filter((x) => this.newOrder.selectedProducts.includes(x.product_id));
            }


            this.setNewOrder(this.newOrder);
        },
        search() {
            this.bus.$emit('getProducts')
        },
        updateProduct(product) {
            console.log(product)
        },
        watchChangedProducts(products, is_quote) {
            console.log("change products",products)
            products.forEach((x) => {
                let prodIndex = this.newOrder.products.findIndex((y) => y.product_id == x.id);
                console.log("prodIndex",prodIndex);
                console.log("x ",x);
                if(is_quote) {
                    prodIndex = this.newOrder.products.findIndex((y) => y.quote_product_id == x.quote_product_id);
                }
                if (prodIndex > -1) {
                    this.newOrder.products[prodIndex].product_num = x.product_num;
                    this.newOrder.products[prodIndex].product_desc = x.product_desc;
                    this.newOrder.products[prodIndex].product_name = x.product_name;
                    this.newOrder.products[prodIndex].qty = x.qty;
                    this.newOrder.products[prodIndex].price = x.price;
                    this.newOrder.products[prodIndex].unit_price = x.price;
                    this.newOrder.products[prodIndex].uom = x.uom;
                    this.newOrder.products[prodIndex].cost = x.cost;
                    this.newOrder.products[prodIndex].qty_unit_id = x.qty_unit_id ? x.qty_unit_id : null;
                    this.newOrder.products[prodIndex].quote_tier_id = x.quote_tier_id ? x.quote_tier_id : null;
                }
            });
            console.log("this.newOrder.products",this.newOrder.products);
            this.setNewOrder(this.newOrder);
        },
        getQuantityUnits() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('so-quantity-units.index'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.quantityUnits = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        inputFilterProduct(event){
            // console.log('inputFilterProduct', event);
        },
        selectFilterProduct(event) {
            //console.log(event);

            this.search_filter = event != null && event.selectedObject ? event.selectedObject.name : '';
            this.initialDisplay = this.search_filter;

            setTimeout(() => {
                this.search_filter = event != null && event.selectedObject ? event.selectedObject.name : '';
                /*if(this.$refs.autocomplete.$el.firstChild.children.length > 2) {
                    console.log(this.$refs.autocomplete.$el.firstChild.children[1].firstChild)
                    this.$refs.autocomplete.$el.firstChild.children[1].firstChild._value =  this.search_filter;
                    console.log(this.$refs.autocomplete.$el.firstChild.children[1].firstChild._value)

                    //Vue.set(this.$refs.autocomplete.display, '', 'some error');
                }*/
                this.search();
            }, 500);
        },
        productSearchEndpoint(input) {
            return window.route('so.products.search', {page: 1, per_page: 20, search_filter: input});
        },
        resultsFormatter(result) {
            // console.log(result)
            if (!result.errorMessage && result.data.products.data.length) {
                let products = [];
                result.data.products.data.forEach((x) => {
                    const div = document.createElement('div')
                    div.innerHTML = x.product_desc
                    let description = div.textContent || div.innerText || ''

                    if(description.length > 100) {
                        description = description.substring(0, 100)+"..."
                    }

                    let product_num = '';
                    if(x.product_num) {
                        product_num = `#${x.product_num}`
                    }

                    products.push({
                        id: x.id,
                        name: x.product_name,
                        description: `${x.product_name} ${product_num} <div class="description"> ${description}</div>`
                    });
                });

                return products;
            }
            return [];
        },
        formattedDisplay(result) {
            //return result.name + ' [' + result.id + ']'
            return result.description;
        }

    },
    watch: {},
    computed: {
        ...mapState([
            'userState',
            'salesOrderState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'ordersLoading',
            'getSalesOrderState',
            'loading',
            'productsLoading',
            'quoteProductsLoading'
        ]),
        authHeaders() {
            return {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }
        },
    }
}
</script>

<style scoped>
.error {
    color: red;
}

.description {
    line-height: 1.5em;
    height: 3em;       /* height is 2x line-height, so two lines will display */
    overflow: hidden;
}

.description p {
    line-height: 1.5em;
    height: 3em;       /* height is 2x line-height, so two lines will display */
    overflow: hidden;
}

.description p:not(:first-child) {
    display: none;
}
</style>
